module.exports = __webpack_public_path__ + "c7cdd39274be2247c17473de407320c2.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/designieumsae/img/empty_img.png
// module id = 2584
// module chunks = 1